export default class Partners {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        $(document).ready(() => {
            this.checkFilter();

            $('.partner-search .icon-search').on('click', (e) => {
                e.preventDefault();
                let parent = $(e.currentTarget).parents('.partner-search');
                parent.toggleClass('open').find('input').focus();
            });

            $('.filter-dropdown-items .partner-type').on('mouseenter', function (e) {
                e.preventDefault();

                if($(window).width() < 1000) return;

                $(this).find('.partner-type__options').addClass('open');
                $(this).find('.partner-type__label').addClass('open');
            });

            $('.filter-dropdown-items .partner-type').on('mouseleave', function (e) {
                e.preventDefault();

                if ($(window).width() < 1000) return;

                $('.partner-type__options.open,.partner-type__label.open').each(function ()  {
                    $(this).removeClass('open')
                })

            });

            $('.partner-type__label').on('click', function () {
                if($(window).width() >= 1000) return;
                $(this).siblings('.partner-type__options').toggleClass('open');
                $(this).toggleClass('open');
            });

            $('.partner-type__options').on('click', '.option', (e) => {
                $(e.currentTarget).toggleClass('active');
                $(e.currentTarget).closest('.partner-type__options').removeClass('open');
                $(e.currentTarget).closest('.partner-type__options').siblings('.partner-type__label').removeClass('open');

                this.generateLink();
            });

            $('.partner-filter__list').on('click', 'div', (e) => {
                e.preventDefault();
                let id = $(e.currentTarget).attr('data-id');
                $(e.currentTarget).remove();
                $(`.partner-type__options .option[data-id="${id}"]`).removeClass('active');

                if ($(e.currentTarget).hasClass('match')) {
                    $('.partner-search input').val('');
                }
                this.generateLink();
            });

            $('.partner-filter__clear').on('click', (e) => {
                e.preventDefault();

                $('.partner-type__options .option').each(function () {
                    $(this).removeClass('active');
                })

                window.location = $('.partner-filter__active .default-url').val();
            });

            $('.partner-search input').on('keyup', (e) => {
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                    this.generateLink();
                }
            });

            $('.mobile-filter-toggle').click(function () {
                $(this).siblings('.filter-dropdown-items').toggleClass('open')
            });

        });

    }

    checkFilter() {
        $('.partner-filter__list div').remove();

        $('.partner-type__options .option.active').each((_, el) => {
            let name = $(el).find('span').text();
            let id = $(el).attr('data-id');
            let slug = $(el).attr('data-slug');
            $('<div data-id="'+id+'" data-slug="'+slug+'">'+name+'</div>').appendTo('.partner-filter__list');
        });

        let search = $('.partner-search input').val();
        if (search) {
            $('<div class="match">Matches <span>“' + search + '”</span></div>').appendTo('.partner-filter__list');
        }

        if ($('.partner-filter__list div').length == 0) {
            $('.partner-filter__active').removeClass('active');
        } else {
            $('.partner-filter__active').addClass('active');
        }

    }

    generateLink() {

        let search = $('.partner-search input').val();
        let activeTerms = [];

        $('.partner-grid__filter .partner-type').each((_, el) => {
            let taxonomy = $(el).attr('data-taxonomy');
            let activeTaxTerms = [];
            $(el).find('.partner-type__options .option.active').each((_, el) => {
                activeTaxTerms.push($(el).attr('data-slug'))
            });
            activeTerms.push({taxonomy :taxonomy, term : activeTaxTerms});
        });

        let url = $('.partner-filter__active .default-url').val() + '/';
        let activeTaxCount = 0;

        activeTerms.forEach((activeTerm, index) => {
            if(activeTerm.term.length > 0){

                if(activeTaxCount === 0){
                    url += '?' + activeTerm.taxonomy + '=' + activeTerm.term.join(',');
                } else{
                    url += '&' + activeTerm.taxonomy + '=' + activeTerm.term.join(',');
                }

                activeTaxCount++
            }
        })

        if (search.length && activeTaxCount) {
            url += '&search=' + search;
        } else if(search.length) {
            url += '?search=' + search;
        }

        window.location = url;
    }
}
